export enum Module {
  Orders = 1,
  FreightExchange = 4,
  Selfbillings = 7,
  Tenders = 8,
  ExWorkBooking = 9,
  // TODO: Remove administration module from front-end and back-end
  Administration = 10,
  Carriers,
  ApproveCarriers,
  Users,
  InstructionDocs,
  Incidents,
  PortalSettings,
}
